module.exports = __webpack_public_path__ + "img/void-chart-select-date.ce9fe626.gif";